var React = require('react');

function IconStop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm0-2.667c7.364 0 13.333-5.97 13.333-13.333 0-7.364-5.97-13.333-13.333-13.333C8.636 2.667 2.667 8.637 2.667 16c0 7.364 5.97 13.333 13.333 13.333Z","clipRule":"evenodd","key":0}),React.createElement("path",{"fill":"currentColor","d":"M10.667 10.667h10.666v10.666H10.667V10.667Z","key":1})]);
}

IconStop.defaultProps = {"fill":"none","viewBox":"0 0 32 32"};

module.exports = IconStop;

IconStop.default = IconStop;
